/* @flow */

export const chunkArray = (arr: any[], chunkSize: number) =>
  arr.reduce(
    (acc, _, i) =>
      // $FlowFixMe
      i % chunkSize ? acc : [...acc, arr.slice(i, i + chunkSize)],
    []
  );
